import { render, staticRenderFns } from "./StudentGradesTableView.vue?vue&type=template&id=7fb80b85"
import script from "./StudentGradesTableView.vue?vue&type=script&lang=js"
export * from "./StudentGradesTableView.vue?vue&type=script&lang=js"
import style0 from "./StudentGradesTableView.vue?vue&type=style&index=0&id=7fb80b85&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports